import UsersList from "../Users/UsersList";
import UserRoleForm from "../Users/UserRoleForm";
import UserForm from "../Users/UserForm";
import ViewUser from "../Users/UserView";

import CardRequestsList from "../CardRequests/ViewAllCardRequests";

import IssuerConfigList from "../IssuerConfiguration/ViewAllIssuerConfigs";

import IssuerConfigForm from "../IssuerConfiguration/IssuerConfigForm";

import IssuerDomainMappingList from "../MapIssuersDomains/ViewAllIssuerDomainMappings";
import IssuerDomainMapForm from "../MapIssuersDomains/IssuerDomainMapForm";
import ViewIssuerConfig from "../IssuerConfiguration/ViewIssuerConfig";
import CardRequestsForm from "../CardRequests/CardRequestsForm";
import ViewCardRequest from "../CardRequests/ViewCardRequest";

import BatchCustomersList from "../Customers/ViewBatchCustomers";
import CustomersList from "../Customers/ViewAllCustomers";
import CardsRecordsList from "../CardRecords/ViewAllCardRecords";

import { permissionsConstants } from "../../constants/permissions.constants";
import ViewCardRecord from "../CardRecords/ViewCardRecord";
import ViewCustomer from "../Customers/ViewCustomer";
import ViewIssuerMapping from "../MapIssuersDomains/ViewIssuerMapping";


const {
  VIEW_CARD_REQUESTS,
  CREATE_CARD,
  VIEW_CARD_REQUEST,
  VIEW_ISSUER_CONFIGURATIONS,
  CREATE_ISSUER_CONFIGURATION,
  VIEW_ISSUER_CONFIGURATION,
  UPDATE_ISSUER_CONFIGURATION,
  VIEW_ISSUER_MAPPINGS,
  VIEW_ISSUER_MAPPING,
  UPDATE_ISSUER_MAPPING,
  CREATE_ISSUER_MAPPING,
  VIEW_USERS,
  VIEW_USER,
  CREATE_USER,
  UPDATE_USER,
  CHANGE_USER_ROLE,
  VIEW_BATCH_CUSTOMERS,
  GET_DOMAIN_CUSTOMERS,
  VIEW_CUSTOMER,
  VIEW_CUSTOMER_CARDS,
  VIEW_CARDS,
  VIEW_CARD_DETAILS
} = permissionsConstants;

export const CardRequestRoutes = {
  enabled: true,
  menu: true,
  routes: [
    {
      key: "cardRequests",
      title: "Card Requests",
      exact: true,
      icon: null,
      name: "CardRequests",
      path: "/card-requests",
      menu: true,
      pageComponent: CardRequestsList,
      enabled: true,
      permissions: [VIEW_CARD_REQUESTS],
    },
    {
      key: "cardRequestCustomers",
      title: "Card Request Customers Cards",
      exact: false,
      icon: null,
      name: "CardRequestCustomers",
      path: "/card-requests/:id/customers",
      menu: true,
      pageComponent: BatchCustomersList,
      enabled: true,
      permissions: [VIEW_BATCH_CUSTOMERS],
    },
    {
      key: "createCard",
      title: "Create Card",
      exact: false,
      icon: null,
      name: "CreateCard",
      path: "/card-requests/create",
      menu: true,
      pageComponent: CardRequestsForm,
      enabled: true,
      permissions: [CREATE_CARD],
    },
    {
      key: "viewCardRequest",
      title: "View Card Request",
      exact: false,
      icon: null,
      name: "ViewCardRequest",
      path: "/card-requests/view/:id",
      menu: true,
      pageComponent: ViewCardRequest,
      enabled: true,
      permissions: [VIEW_CARD_REQUEST],
    },
    {
      key: "viewRequestDetails",
      title: "View Request Details",
      exact: false,
      icon: null,
      name: "ViewRequestDetails",
      path: "/card-requests/customers/1",
      menu: true,
      pageComponent: ViewCardRequest,
      enabled: true,
      permissions: [VIEW_CARD_REQUEST],
    },
  ],
};

export const CustomerRoutes = {
  enabled: true,
  menu: true,
  routes: [
    {
      key: "customers",
      title: "Customers",
      exact: true,
      icon: null,
      name: "CardRequests",
      path: "/customers",
      menu: true,
      pageComponent: CustomersList,
      enabled: true,
      permissions: [GET_DOMAIN_CUSTOMERS],
    },
    {
      key: "customercards",
      title: "Customer Cards",
      exact: false,
      icon: null,
      name: "CustomerCards",
      path: "/customers/cards",
      menu: true,
      pageComponent: CardsRecordsList,
      enabled: true,
      permissions: [VIEW_CUSTOMER_CARDS],
    },
    {
      key: "editCustomers",
      title: "Edit Customers",
      exact: false,
      icon: null,
      name: "EditCustomers",
      path: "/customers/edit/:id",
      menu: true,
      pageComponent: ViewCardRequest,
      enabled: true,
      permissions: [VIEW_CUSTOMER],
    },
    {
      key: "viewCustomer",
      title: "View ",
      exact: false,
      icon: null,
      name: "ViewRequestDetails",
      path: "/customers/view/:id",
      menu: true,
      pageComponent: ViewCustomer,
      enabled: true,
      permissions: [VIEW_CUSTOMER],
    },
  ],
};

// export const AuditTrailRoutes = {
//   enabled: true,
//   menu: false,

//   key: "AuditTrail",
//   title: "Audit Records",
//   exact: true,

//   name: "AudItTrail",
//   path: "/audit-trail",

//   pageComponent: AuditTrail,

//   permissions: [VIEW_AUDIT_TRAIL],
// };

export const CardRecordsRoutes = {
  enabled: true,
  menu: true,
  routes: [
    {
      key: "cardRecords",
      title: "Card Records",
      exact: true,
      icon: null,
      name: "CardRecords",
      path: "/cards",
      menu: false,
      pageComponent: CardsRecordsList,
      enabled: false,
      permissions: [VIEW_CARDS],
    },
    {
      key: "viewCardRecord",
      title: "View Card Record",
      exact: false,
      icon: null,
      name: "ViewCardRecord",
      path: "/cards/view/:id",
      menu: true,
      pageComponent: ViewCardRecord,
      enabled: true,
      permissions: [VIEW_CARD_DETAILS],
    },
  ],
};

export const IssuerConfigRoutes = {
  enabled: true,
  menu: true,
  routes: [
    {
      key: "issuerConfigs",
      title: "Issuer Card Configuration",
      exact: true,
      icon: null,
      name: "CardConfigs",
      path: "/issuers/config",
      menu: true,
      pageComponent: IssuerConfigList,
      enabled: true,
      permissions: [VIEW_ISSUER_CONFIGURATIONS],
    },
    {
      key: "addIssuerConfigs",
      title: "Set Issuer Configuration",
      exact: false,
      icon: null,
      name: "AddIssuerConfiguration",
      path: "/issuers/config/new",
      menu: true,
      pageComponent: IssuerConfigForm,
      enabled: true,
      permissions: [CREATE_ISSUER_CONFIGURATION],
    },
    {
      key: "viewIssuerConfig",
      title: "View Issuer Config",
      exact: false,
      icon: null,
      name: "ViewIssuerConfig",
      path: "/issuers/config/view/:issuerCode/:id",
      menu: true,
      pageComponent: ViewIssuerConfig,
      enabled: true,
      permissions: [VIEW_ISSUER_CONFIGURATION],
    },
    {
      key: "editIssuerConfig",
      title: "Edit Issuer Config",
      exact: false,
      icon: null,
      name: "EditIssuerConfig",
      path: "/issuers/config/edit/:issuerCode/:id",
      menu: true,
      pageComponent: IssuerConfigForm,
      enabled: true,
      permissions: [UPDATE_ISSUER_CONFIGURATION],
    },
  ],
};

export const IssuerDomainMappingRoutes = {
  enabled: true,
  menu: true,
  routes: [
    {
      key: "issuerDomainMapping",
      title: "Issuer Domain Mapping",
      exact: true,
      icon: null,
      name: "IssuerDomainMapping",
      path: "/issuer-mapping",
      menu: true,
      pageComponent: IssuerDomainMappingList,
      enabled: true,
      permissions: [VIEW_ISSUER_MAPPINGS],
    },
    {
      key: "addIssuerDomainMapping",
      title: "New Issuer Domain Mapping",
      exact: false,
      icon: null,
      name: "AddIssuerDomainMapping",
      path: "/issuer-mapping/add",
      menu: true,
      pageComponent: IssuerDomainMapForm,
      enabled: true,
      permissions: [CREATE_ISSUER_MAPPING],
    },
    {
      key: "viewIssuerMapping",
      title: "View Issuer Mapping",
      exact: false,
      icon: null,
      name: "ViewIssuerMapping",
      path: "/issuer-mapping/view/:domainCode",
      menu: true,
      pageComponent: ViewIssuerMapping,
      enabled: true,
      permissions: [VIEW_ISSUER_MAPPING],
    },
    {
      key: "editIssuerConfig",
      title: "Edit Issuer Config",
      exact: false,
      icon: null,
      name: "EditIssuerConfig",
      path: "/issuer-mapping/edit/:domainCode/:issuerCode",
      menu: true,
      pageComponent: IssuerDomainMapForm,
      enabled: true,
      permissions: [UPDATE_ISSUER_MAPPING],
    },
  ],
};

export const UserRoutes = {
  enabled: true,
  menu: true,
  routes: [
    {
      key: "users",
      title: "User Management",
      exact: true,
      icon: null,
      name: "Users",
      path: "/users",
      menu: true,
      pageComponent: UsersList,
      enabled: true,
      permissions: [VIEW_USERS],
    },
    {
      key: "addUser",
      title: "Add User",
      exact: false,
      icon: null,
      name: "Add Users",
      path: "/users/add",
      menu: false,
      pageComponent: UserForm,
      enabled: true,
      permissions: [CREATE_USER],
    },
    {
      key: "viewUser",
      title: "View User",
      exact: false,
      icon: null,
      name: "View User",
      path: "/users/view/:id",
      menu: false,
      pageComponent: ViewUser,
      enabled: true,
      permissions: [VIEW_USER],
    },
    {
      key: "editUser",
      title: "Edit User",
      exact: false,
      icon: null,
      name: "Edit Users",
      path: "/users/edit/:id",
      menu: false,
      pageComponent: UserForm,
      enabled: true,
      permissions: [UPDATE_USER],
    },
    {
      key: "manageUserRole",
      title: "Manage User Role",
      exact: false,
      icon: null,
      name: "Manage User Role",
      path: "/users/roles/:id",
      menu: false,
      pageComponent: UserRoleForm,
      enabled: true,
      permissions: [CHANGE_USER_ROLE],
    },
  ],
};
